export default {
  seeUnarchivedCampaigns: '查看未存档的广告系列',
  seeArchivedCampaigns: '查看存档的广告系列',
  sendMassSms: '发送大量短信',
  mustChargeBeforeSendingCampaigns: '在发送活动之前，您必须收取费用',
  sendSmsCampaignFromFile: '从文件发送 SMS 活动',
  createCampaign: '创建市场活动',
  sendCampaignToDirectory: '将市场活动发送到您的人员目录',
  forms: '形式',
  unArchive: '取消存档',
  archive: '档案',
  loadingCampaigns: '加载市场活动',
  noCampaignsCreated: '您尚未创建任何广告系列',
  type: '类型',
  status: '地位',
  campaignSuccessfullyArchived: '已成功存档市场活动',
  sendCampaign: '发送市场活动',
  shippingDateAndTime: '发货日期和时间',
  scheduleCampaign: '计划活动',
  campaignReadyAndWaitingToBeSent: '您的广告系列已准备就绪，正在等待发送',
  schedule: '附表',
  export: '出口',
  campaignStatus: '市场活动状态',
  campaignScope: '市场活动范围',
  messagesToBeSent: '要发送的消息',
  thisValueCouldChange: '此值可能会更改',
  finalValue: '最终值',
  sendingDate: '发送日期',
  campaignProgress: '市场活动进度',
  moreCounters: '更多计数器',
  lessCounters: '更少的计数器',
  importingPeopleProgress: '输入人员的进度',
  importedPeople: '输入人员',
  peopleAmount: '人员数量',
  importingErrors: '导入错误',
  sending: '发送',
  sent: '已发送 |已发送 |送',
  onStandBy: '待机状态',
  onDraft: '关于草稿',
  scheduled: '计划',
  all: '所有',
  pending: '等待',
  deliveredToCarrier: '交付给运营商',
  rejected: '已拒绝 |拒绝',
  postponed: '已推迟 |推迟',
  hardRebound: '硬反弹 |硬反弹',
  softRebound: '软反弹 |软反弹',
  opened: '已打开 |打开',
  inSpam: '在垃圾邮件中',
  terminated: '已终止 |终止',
  inBlackList: '在黑名单中',
  inWhiteList: '在白列表中',
  messagePart: '消息部分 |消息部件',
  delivered: '交付',
  importMorePeople: '导入更多人',
  loadingUsers: '正在加载用户',
  clicked: '点击',
  multiParts: '多部件',
  seeMessage: '请参阅消息',
  noUserDefinedMessage: '此用户没有已定义的消息',
  youAreSeeingTheMessageOf: '您看到的是',
  nameOfTheMassSms: '群发短信的名称',
  insertMassSmsKeyName: '插入一个 SMS 密钥名称，帮助您记住此短信的内容',
  noFilePicked: '您尚未选择任何文件',
  downloadFormat: '下载格式',
  prepareMassSms: '准备群发短信',
  insertMassSmsName: '插入大量短信的名称',
  mustPickSmsFile: '您必须选择 SMS 文件',
  campaignSuccessfullyCreated: '已成功创建市场活动',
  campaignName: '市场活动名称',
  insertMassCampaignKeyName: '插入一个市场活动键名称，帮助您记住此市场活动的内容',
  campaignType: '市场活动类型',
  pickCampaignType: '选择市场活动类型',
  writeYourMessageHere: '在此处撰写邮件',
  pickPeopleList: '选择人员列表',
  pickOrCreateListOfPeopleToCommunicateMessage: '选择要传达邮件的人员列表或创建从外部文件导入邮件的新列表',
  allPeople: '所有人',
  waitWhileTheListGetsCreated: '创建列表时等待',
  noPeopleListPicked: '您尚未选择任何人员列表',
  addYourFirstCondition: '添加第一个条件',
  addAnotherCondition: '添加其他条件',
  attributeCondition: '属性条件',
  actionCondition: '操作条件',
  segmentPeopleByAttributesAndActions: '您可以根据与公司交互的人员进行细分，包括其属性或平台内执行的操作。',
  youAreAlmostDone: '你快完了！',
  yourMessageScope: '您的消息将到达 [人数] 人',
  prepareCampaign: '准备活动',
  insertMessageSubject: '插入消息主题',
  insertMessageHtml: '插入消息 html',
  createHtmlTemplate: '创建您的模板',
  importPeople: '导入人员',
  insertCampaignName: '插入市场活动名称',
  insertCampaignType: '插入市场活动类型',
  subject: '主题',
  insertHtmlTemplate: '在下一个字段中输入 html 模板',
  previewTemplate: '预览模板',
  customize: '自定义',
  from: '从',
  until: '直到',
  attribute: '属性',
  contains: '包含',
  noContains: '不包含',
  is: '是',
  isNot: '不是',
  addANameToYourTemplate: '為模板添加名稱',
  templateName: '模板名稱',
  save: '救',
  // Triggers
  triggers: '触发器',
  noTitle: '无标题',
  loadingTriggers: '加载触发器',
  noRegisteredTriggers: '没有注册的触发器',
  title: '标题',
  executeTriggerWhenActionFire: '触发操作时执行触发器',
  customActionToFilter: '自定义操作以筛选',
  actionsToExecute: '要执行的操作',
  emailBody: '电子邮件正文',
  smsBody: '短信的身体',
  postRequestData: 'POST 请求数据',
  saveTrigger: '保存触发器',
  trigger: '触发',
  new: '新增功能',
  edit: '编辑',
  add: '添加',
  triggerDetails: '触发详细信息',
  triggerScope: '触发器的范围',
  editTrigger: '編輯觸發器',
  createTrigger: '創建觸發器',
  triggerSuccessfullyCreated: '觸發成功建立',
  triggerSuccessfullyUpdated: '觸發成功更新',
  launchers: '发射',
  actionType: '[操作] 操作',
  addNotification: '添加通知',
  notifications: '通知',
  loadingNotifications: '正在加载通知',
  noNotificationsCreated: '未创建通知',
  newNotification: '新通知',
  notificationCreatedSuccessfully: '已成功创建通知',
  editNotification: '编辑通知',
  notificationEditedSuccessfully: '已成功编辑通知',
  youDontHaveNotifications: '您没有通知',
  invalidFileType: '无效的文件类型',
  noDataFound: '没有找到数据',
  clickOnYourFileTypeOrDragHere: '点击您的文件类型或将其拖到这里',
  filesSize: '不支持大于5Mbs的文件',
  findQuickAnswer: '搜索快速反应',
  noAnswerFound: '我们没有找到你要找的答案。',
  titleNewInformation: '新信息的标题',
  waitingForAttention: '等待关注',
  terminationReason: '完成原因',
  findTerminationReason: '查找终止的原因',
  nameless: '无名',
  conversationClassification: '谈话的分类',
  withoutAdvisor: '无顾问',
  you: '你',
  agents: '代理商',
  // missing translations
  advisors: '顾问',
  conversations: '对话内容',
  host: '主办',
  attended: '参加',
  noAttended: '不参加',
  responseTime: '响应时间',
  noAttendedConversations: '未答复的对话',
  attendedConversations: '参加对话',
  totalConversations: '对话总数',
  lastMonth: '上个月',
  phone: '蜂窝电话',
  organic: '有机食品',
  conversationsPerChannel: '频道对话',
  createdPeople: '人们创造了',
  waitTime: '等待时间',
  yesterday: '前一天',
  withBot: '与机器人',
  assignTaskAfterSettingJourney: '分配行程状态后分配任务',
  pickAJourneyStatus: '选择旅程的状态',
  journeys: '旅程',
  timeInMinutesToCreateTaskAfterSettingJourney: '分配行程后创建任务的时间（分钟）。',
  untrainedQuestions: '未经训练的问题',
  numberOfQuestions: '问题数量',
  serviceRating: '服务资格',
  usersWhoGotProactivity: '获得主动的用户',
  bot: '机器人',
  questions: '疑问',
  operator: '运营商',
  time: '天气预报',
  attendedAndUnansweredConversations: '参加和未参加的对话',
  total: '总',
  pickExtraData: '選擇額外的數據',
  pickExtraDataFieldAndValue: '選擇額外的數據字段和值',
  writeExtraDataValue: '寫額外的數據值',
  campaignInformation: '活動信息',
  // Trigger to do list translations
  smsToUser: '向用戶發送短信',
  emailToUser: '向用戶發送電子郵件',
  postRequestToServer: '向服務器發送請求',
  createTaskForUser: '為用戶創建任務',
  // Trigger action types translations
  ACTION_CUSTOM: '自定義操作',
  ACTION_REGISTER_EMAIL: '在電子郵件註冊上',
  ACTION_REGISTER_PHONE: '在電話註冊上',
  ACTION_REGISTER_VERIFIED: '在註冊成功上',
  ACTION_REGISTER_EMAIL_RESEND: '在重新發送註冊電子郵件上',
  ACTION_REGISTER_SOCIAL: '在註冊上社交網絡',
  ACTION_REGISTER_GOOGLE: '向用戶發送電子郵件0',
  ACTION_REGISTER_FACEBOOK: '向用戶發送電子郵件1',
  ACTION_REGISTER_SPOTIFY: '向用戶發送電子郵件2',
  ACTION_REGISTER_INSTAGRAM: '向用戶發送電子郵件3',
  ACTION_REGISTER_APPLEID: '向用戶發送電子郵件4',
  ACTION_REGISTER_EMAIL_FAIL: '向用戶發送電子郵件5',
  ACTION_REGISTER_PHONE_FAIL: '向用戶發送電子郵件6',
  ACTION_LOGIN_EMAIL: '向用戶發送電子郵件7',
  ACTION_LOGIN_PHONE: '向用戶發送電子郵件8',
  ACTION_LOGIN_SOCIAL: '向用戶發送電子郵件9',
  ACTION_LOGIN_GOOGLE: '向服務器發送請求0',
  ACTION_LOGIN_FACEBOOK: '向服務器發送請求1',
  ACTION_LOGIN_INSTAGRAM: '向服務器發送請求2',
  ACTION_LOGIN_SPOTIFY: '向服務器發送請求3',
  ACTION_LOGIN_APPLEID: '向服務器發送請求4',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: '向服務器發送請求5',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: '向服務器發送請求6',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: '向服務器發送請求7',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: '向服務器發送請求8',
  ACTION_LOGIN_EMAIL_FAIL: '向服務器發送請求9',
  ACTION_LOGIN_EMAIL_FAIL_USER: '為用戶創建任務0',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: '為用戶創建任務1',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: '為用戶創建任務2',
  ACTION_LOGIN_PHONE_FAIL: '為用戶創建任務3',
  ACTION_LOGIN_PHONE_FAIL_USER: '為用戶創建任務4',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: '為用戶創建任務5',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: '為用戶創建任務6',
  ACTION_RESET_PASSWORD_PHONE: '為用戶創建任務7',
  ACTION_RESET_PASSWORD_EMAIL: '為用戶創建任務8',
  ACTION_RESET_VALIDATION: '為用戶創建任務9',
  ACTION_RESET_OTP: '自定義操作0',
  ACTION_LOGOUT: '自定義操作1',
  ACTION_SUBMIT: '自定義操作2',
  ACTION_SUBMIT_FILE: '自定義操作3',
  ACTION_USER_IMAGE: '自定義操作4',
  ACTION_EVENT_PURCHASE: '自定義操作5',
  ACTION_EVENT_PURCHASE_CONFIRMATION: '自定義操作6',
  ACTION_USER_CHANGE: '自定義操作7',
  ACTION_ON_JOURNEY_SET: '自定義操作8',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: '自定義操作9',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: '在電子郵件註冊上0',
  attachFiles: '附加檔案',
  attachFilesInCampaignDescription: `
  為了將文件附加到您的電子郵件廣告系列，
  您附加的每個文件只能重5mb，文件的總大小
  重量必須小於 {size} {units}.
  `,
  sizeOfFileCantExceed: '每個文件的大小不能超過 {size} {units}',
  filesTotalSizeMustBeSmallerThan: '文件的總大小不能超過 {size} {units}',
  attachedFiles: '附加的文件',
  fileSuccessfullyDeleted: '文件已成功刪除',
  fileWithSameNameAlreadyExists: '具有相同名稱的文件已存在',
  filesSuccessfullyAttached: '文件成功附加'
}
